import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches a single consultation with all nested relations (vitals, notes, treatments). */
export function useGetConsultation(id: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['consultation', id],
    queryFn: async () => {
      const response = await api.get('/consultations/:id', { params: { id } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.consultation
    },
    enabled: !!id,
  })
}
